import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ALL_SHORTAGE_DATA } from './shortage-data';
import { Chart, registerables } from 'chart.js';
import { ShortageOverviewService } from './shortage-overview/shortage-overview.service';
import { AppConstants } from '../../app.constants';

Chart.register(...registerables);

const TAB_STORAGE_KEY = 'shortage_panel_active_tab';

@Component({
  selector: 'app-shortage-panel',
  templateUrl: './shortage-panel.component.html',
  styleUrl: './shortage-panel.component.scss'
})
export class ShortagePanelComponent implements OnInit {
  allData: any[] = ALL_SHORTAGE_DATA;
  currentMode: 'NDC' | 'Products' = 'Products';
  currentView: string = 'overview';

  // Total Count in Header
  totalCount: number = 0;
  lastUpdated: string = '';


  // Shared Filters for Explorer
  explorerInitialFilters: any = {};

  constructor(private overviewService: ShortageOverviewService) { }

  ngOnInit(): void {
    // Restore last active tab from sessionStorage (auto-cleared on tab close)
    const savedTab = sessionStorage.getItem(TAB_STORAGE_KEY);
    const validTabs = ['overview', 'changelog', 'timeline', 'explorer'];
    if (savedTab && validTabs.includes(savedTab)) {
      this.currentView = savedTab;
    }
    this.fetchTotalCount();
  }

  fetchTotalCount(): void {
    const email = localStorage.getItem('email') || "";
    const viewType = this.currentMode.toLowerCase();
    this.overviewService.getOverviewData(email, viewType).subscribe({
      next: (res) => {
        if (res.counts) {
          this.totalCount = viewType === 'ndc' ? res.counts.ndc : res.counts.products;
        }
        if (res.excel_uploaded_date) {
          this.lastUpdated = res.excel_uploaded_date;
        }
      }
    });
  }

  switchView(viewId: string): void {
    this.currentView = viewId;
    sessionStorage.setItem(TAB_STORAGE_KEY, viewId);
    if (viewId !== 'explorer') {
      this.explorerInitialFilters = {}; // Reset filters when switching to other tabs
    }
  }

  handleModeToggle(event: any): void {
    this.currentMode = event.target.checked ? 'NDC' : 'Products';
    this.fetchTotalCount();
  }

  filterAndRedirect(event: any): void {
    const type = typeof event === 'string' ? event : event.type;
    const ids = typeof event === 'object' ? event.ids : null;

    this.currentView = 'explorer';
    sessionStorage.setItem(TAB_STORAGE_KEY, 'explorer');

    if (type === 'Active') {
      this.explorerInitialFilters = {
        lmsFlagFilter: this.currentMode === 'Products' ? '1' : '-1',
        statusFilter: '',
        ids: ids
      };
    } else if (type === 'Current') {
      this.explorerInitialFilters = {
        lmsFlagFilter: '1',
        statusFilter: 'Current',
        ids: ids
      };
    } else if (type === 'Discontinued') {
      this.explorerInitialFilters = {
        lmsFlagFilter: '1',
        statusFilter: 'To Be Discontinued',
        ids: ids
      };
    } else if (type === 'Resolved') {
      this.explorerInitialFilters = {
        lmsFlagFilter: '4',
        statusFilter: '',
        ids: ids
      };
    } else if (type === 'New') {
      this.explorerInitialFilters = {
        currentExplorerMode: 'NewThisMonth',
        ids: ids
      };
    }
  }

}

